<template>
  <div>
    <div v-for="(section, i) in content" :key="i">
      <div class="d-flex">
        <!-- content head -->
        <div class="w-300px mr-5">
          <h3 class="mb-10px">Section</h3>
          <div class="h4">
            至少需填寫一組內容 <br />
            可添加欄位做內容填充
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="block mb-5">
            <!-- content -->
            <div
              class="form-item py-5 d-flex align-center justify-lg-space-between"
            >
              <h4>Section</h4>
              <button
                v-if="i > 0"
                class="btn btn-danger square w-32px h-32px"
                @click="deleteItem(i)"
              >
                <v-icon color="white">delete</v-icon>
              </button>
            </div>
            <!-- Title -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-160px mr-5">Title</h4>
              <div class="my-n2 flex-grow-1">
                <v-text-field
                  v-model="section.title"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
          </div>
          <!-- content body -->
          <div class="block mb-5"  v-for="(item, index) in section.content" :key="index">
            <!-- content -->
            <div
              class="form-item py-5 d-flex align-center justify-lg-space-between"
            >
              <h4>Content</h4>
              <button
                class="btn btn-danger square w-32px h-32px"
                @click="deleteContentItem(section.content, index)"
              >
                <v-icon color="white">delete</v-icon>
              </button>
            </div>
            <!-- Title -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-160px mr-5">Name</h4>
              <div class="my-n2 flex-grow-1">
                <v-text-field
                  v-model="item.name"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Title -->
            <label class="form-item d-flex pt-5">
              <h4 class="w-160px mr-5">Title</h4>
              <div class="my-n2 flex-grow-1">
                <v-text-field
                  v-model="item.title"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </label>
            <!-- Description -->
            <label class="form-item d-flex py-5">
              <h4 class="w-160px mr-5">Description</h4>
              <div class="my-n2 flex-grow-1">
                <editor
                  :key="`${item.title}${i}`"
                  v-model="item.description"
                  :height="200"
                  :plugins="'lists'"
                  :toolbar="'bullist numlist'">
                </editor>
              </div>
            </label>
            <!-- Image -->
            <div class="form-item d-flex px-5 py-5">
              <div class="w-180px">
                <h4 class="mb-10px">Image</h4>
                <div class="h5 ink-02-medium--text">
                  建議尺寸：999px * 999px <br />
                  檔案大小限制：&lt; 1 MB
                </div>
              </div>
              <div class="d-flex justify-end flex-grow-1">
                <ImgUploader
                  :imageUrl.sync="item.image"
                  dir="ir"></ImgUploader>
              </div>
            </div>
          </div>
          <!-- add Content Section -->
          <div class="mt-5 mb-9">
            <button class="btn btn-outlined w-100 justify-start" @click="addItem(section.content)">
              <v-icon class="primary--text mr-2">add_circle</v-icon>
              <span>添加Content</span>
            </button>
          </div>
        </div>
      </div>
      <div class="page-divider mb-5"></div>
    </div>

    <div class="mt-5 mb-9">
      <button class="btn btn-outlined w-100 justify-start" @click="$emit('addItem')">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Section</span>
      </button>
    </div>
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="$emit('cancelHandler')">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="$emit('saveHandler')">
        <span>儲存</span>
      </button>
    </div>
  </div>
</template>

<script>
import Editor from '@/components/TinymceEditor.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Editor,
    ImgUploader,
  },
  methods: {
    addItem(content) {
      const template = {
        name: '',
        title: '',
        experience: '',
        education: '',
        image: '',
      };

      content.push(template);
    },
    deleteItem(index) {
      this.content.splice(index, 1);
    },
    deleteContentItem(content, index) {
      content.splice(index, 1);
    },
  },
};
</script>

<style></style>
